export const geoFetch = (url: string): Promise<Response> => {
  return fetch(`/api/explore/geo_proxy?url=${encodeURIComponent(url)}`)
}
